import Vue from 'vue'

import router from './router'
import App from './App.vue'
import store from '@/util/store'

import './util/Interception'

import ElementUI from 'element-ui';
import i18n from './lang' // internationalization
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
// 导入字体图标
import './assets/fonts/iconfont.css'
// 导入全局样式

import './assets/css/global.css'
import _ from 'lodash'


import moment from "moment"

Vue.prototype.$moment = moment;

Vue.prototype._ = _

Vue.config.productionTip = false
new Vue({
  router,
  store,
  i18n,
  beforeCreate(){
    Vue.prototype.$bus = new Vue()
  },
  render: h => h(App)
}).$mount('#app')